
























































































































import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public active = 0;
  public list = [
    "1.获取汇款账号备份",
    "2.转账(或汇款)",
    "3.提供游戏信息",
    "4.客服确认汇款",
    "5.游戏查收元宝",
  ];
  // public mounted() {}
}
